import './main.css';

import automodal from 'automodal';
import flexscroll from 'flexscroll';

const buttons = document.querySelectorAll('.wp-block-button__link, .Header__actions a, .StickyHeader__actions a');

for (const button of buttons) {
  button.addEventListener('mousemove', ({ offsetX, offsetY }) => {
    button.style.setProperty('--button-x', `${offsetX}px`);
    button.style.setProperty('--button-y', `${offsetY}px`);
  });
}

const modals = document.querySelectorAll('[rel~="modal"]');

for (const modal of modals) {
  automodal(modal);
}

const sliders = document.querySelectorAll('[data-flexscroll]');

for (const slider of sliders) {
  const viewport = slider.querySelector('[data-flexscroll-viewport]');
  const counter = slider.querySelector('[data-flexscroll-counter]');

  flexscroll(slider);

  if (viewport && counter) {
    let detail;
    let timeout;

    const update = () => {
      const { items, active } = detail;

      if (active.length) {
        const visible = active.length - 1;
        const current = active[visible] + 1 - visible;
        const total = items.length - visible;

        counter.innerHTML = `${current} / ${total}`;
      }
    };

    slider.addEventListener('change', (e) => {
      detail = e.detail;
      clearTimeout(timeout);
      timeout = setTimeout(update, 100);
    });

    viewport.addEventListener('scroll', () => {
      clearTimeout(timeout);
      timeout = setTimeout(update, 100);
    });
  }
}

const tables = document.querySelectorAll('.wp-block-table');

for (const table of tables) {
  const labels = [...table.querySelectorAll('th')].map((th) => th.innerText);
  const rows = table.querySelectorAll('tbody tr, tfoot tr');

  for (const row of rows) {
    const tds = row.querySelectorAll('td');

    for (const [i, td] of tds.entries()) {
      labels[i] && td.setAttribute('aria-label', labels[i]);
    }
  }
}

const animates = document.querySelectorAll('[data-animate]');

const observer = new IntersectionObserver((entries) => {
  let delay = 0;
  for (const entry of entries) {
    const { isIntersecting, target } = entry;
    if (target.getAttribute('data-animate') !== 'true' && isIntersecting) {
      setTimeout(() => {
        target.setAttribute('data-animate', 'true');
      }, delay);
      delay += 150;
    }
  }
});

for (const animate of animates) {
  observer.observe(animate);
};
